'use strict';

var RulesConfig = function RulesConfig($stateProvider) {
  $stateProvider.state('app.rules', {
    url: '/workflow/rules',
    ifFeatureEnabled: ['REVENUE_OPTIMIZER'],
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: require('../templates/rules-workflow.html')
      },
      'mainToolbar': {
        template: require('../templates/rules-toolbar.html'),
        controller: 'RulesToolbarController'
      }
    }
  });
};
RulesConfig.$inject = ['$stateProvider'];
module.exports = RulesConfig;